<template>
  <div class="px-0 w-100" data-testid="rules-page">
    <div class="header d-flex justify-content-between i-mb-9">
      <div>
        <h5 class="i-text-heading-5 i-text-neutral-120 i-mb-2">Fraud Rules</h5>
        <p class="i-text-body-2 i-text-neutral-110">Manage fraud rules</p>
      </div>
      <div class="d-flex align-items-center">
        <i-button
          class="mr-2"
          text="New Rule"
          type="neutral"
          subtype="subtle"
          data-testid="new-rule-button"
          size="md"
          @button-click="addRule()"
        ></i-button>

        <i-button
          text="Save"
          data-testid="save-rules-button"
          size="md"
          :disabled="!isValidRuleSet"
          @button-click="saveRules()"
        ></i-button>
      </div>
    </div>
    <div class="pb-4 mb-4 align-items-start rules-list">
      <h5 class="i-text-heading-6 i-text-neutral-120">Custom rules</h5>
      <div v-if="rulesSchema.variables" class="d-flex flex-column w-100">
        <div
          class="d-flex flex-column w-100 custom-rules"
          data-testid="custom-rules"
        >
          <rule
            v-for="(rule, index) in rules.filter((r) => !r.default)"
            :key="`${index}-${JSON.stringify(rule)}`"
            :rule="rule"
            :is-custom-fraud-rule="true"
          />
          <div
            v-if="rules.filter((r) => !r.default).length === 0"
            class="rules-empty-state d-flex flex-column justify-content-center align-items-center p-4"
          >
            <h5 class="i-text-subheading-1 i-text-neutral-110">
              You haven't made any custom rules yet
            </h5>
            <i-button
              text="Create a Rule"
              type="primary"
              subtype="outline"
              data-testid="create-a-rule-button"
              size="sm"
              @button-click="addRule()"
            ></i-button>
          </div>
        </div>
        <div class="d-flex mt-4 align-items-center">
          <h5 class="i-text-heading-6 i-text-neutral-120">Default rules</h5>
          <help-tooltip
            class="ml-2"
            text="Default rules are created by Inscribe, to improve your experience they can be enabled or disabled to your preference"
          />
        </div>
        <div class="d-flex flex-column w-100" data-testid="default-rules">
          <rule v-for="rule in notDetectors" :key="rule.name" :rule="rule" />
        </div>
      </div>
      <i-spinner v-else size="sm" class="mx-auto my-5"></i-spinner>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { HelpTooltip } from '@inscribe/ui-kit';
import { iButton, iSpinner } from '@inscribe/signal';
import Rule from '@/V2/decision-engine/Rule';
import RuleEngine from '@/utils/ruleEngine';
import { DETECTOR_RESULTS } from '@/constants/requirementVariables';

export default {
  components: {
    'help-tooltip': HelpTooltip,
    iButton,
    iSpinner,
    rule: Rule,
  },
  data() {
    return {
      RuleEngine,
      showNewRuleModal: false,
      newRule: null,
      ruleError: null,
      mode: '',
    };
  },
  computed: {
    ...mapGetters({
      rules: 'getRules',
      rulesSchema: 'getRulesSchema',
      isOrgAdmin: 'isOrgAdmin',
    }),

    notDetectors() {
      return this.rules.filter(
        (r) => r.default && !RuleEngine.isSimpleDetectorRule(r),
      );
    },

    isValidRuleSet() {
      return (
        this.rulesSchema &&
        this.rulesSchema.variables &&
        new RuleEngine(this.rulesSchema).isValidRuleSet(this.rules, (rule) => {
          return (
            rule.default ||
            rule.conditions.all.some(
              (condition) => condition.name === DETECTOR_RESULTS,
            )
          );
        })
      );
    },
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.getConfigRules();
    }
  },
  methods: {
    ...mapActions({
      getConfigRules: 'getConfigRules',
    }),

    ...mapMutations({
      setRules: 'setRules',
    }),
    addRule() {
      const newRules = [
        ...this.rules,
        {
          actions: [{ name: 'fraudulent_rule_result' }],
          conditions: {
            all: [
              {
                name: 'detector_results',
                operator: 'shares_at_least_one_element_with',
                value: [],
              },
            ],
          },
        },
      ];
      this.setRules(newRules);
      const newRule = document.querySelector(
        '.custom-rules .rule-wrapper:last-of-type',
      );

      if (newRule) {
        newRule.scrollIntoView(true);
      }
    },
    saveRules() {
      this.$emit('save-rules', this.rules);
    },
  },
};
</script>
